<!--
 * @Author: DESKTOP-90MI9K1\admin yangxiong
 * @Date: 2025-02-28 11:53:15
 * @LastEditors: DESKTOP-90MI9K1\admin yangxiong
 * @LastEditTime: 2025-05-12 14:09:20
 * @FilePath: \xypt-vue\src\components\footer\index.vue
 * @Description: 
 * 
 * Copyright (c) 2025 by 抠脚老汉, All Rights Reserved. 
-->
<template>
  <div class="footer-box">
    <div class="out-box column-center-c">
      <div class="flex flex-wrap">
        <div class="item m-b-30" v-for="(item, index) in footerContactList" :key="index">
          <div class="flex">
            <img width="24px" class="m-r-19" :src="item.imgUrl" />
            <span class="font-16 line-h-24 ">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="line flex-center">
        <div class="flex" :style="{ cursor: item.url ? 'pointer' : '' }" @click="handleWeb(item)"
          v-for="(item, index) in footerRecordList" :key="index">
          <div>{{ item.label }}</div>
          <div v-if="index !== footerRecordList.length - 1" class="m-l-30 m-r-30">|</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      footerContactList: [
        { id: 1, name: '客服电话1：0851-8411 2474  /  客服电话2：0851-8857 7587', imgUrl: require('@/assets/index/footer-contact1.png') },
        { id: 2, name: '客服QQ：2881269953', imgUrl: require('@/assets/index/footer-contact2.png') },
        { id: 3, name: '邮箱：2881269953@qq.com', imgUrl: require('@/assets/index/footer-contact3.png') },
        { id: 4, name: '地      址：贵州省贵阳市观山湖区诚信北路8号绿地联盛国际5号楼一单元30层1号', imgUrl: require('@/assets/index/footer-contact4.png') },
      ],
      footerRecordList: [
        { id: 1, label: '技术单位：圣辉征信有限公司', url: '', imgUrl: '' },
        { id: 2, label: '信息监管单位 ：贵阳市招标采购协会', url: '', imgUrl: '' },
        { id: 3, label: '黔ICP备18004720号-3', url: 'https://beian.miit.gov.cn/', imgUrl: '' },
        // { id: 4, label: '贵公网安务52011502001600号', url: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52011502001600', imgUrl: '/static/img/index/badge.png' },
      ],
    }
  },
  methods: {
    handleWeb ({ url }) {
      if (!url) return false
      window.open(url, '_blank')
    }
  },
}
</script>
<style lang="scss" scoped>
.footer-box {
  min-width: 1366px;
  background-color: #222222;

  .out-box {
    width: 1366px;
    margin: 0 auto;
    height: 280px;

    .item {
      width: 50%;
      color: #EAEAEA;
    }

    .line {
      border-top: 1px solid #404040;
      color: #909090;
      padding-top: 30px;
    }
  }
}
</style>